import React from 'react';
import { useStorage } from '~Components/Storage';
import SelectList from '~ComponentsImproved/SelectList';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useDispatch, useI18n, useLogger, useSelector } from '~Hooks';
import { Box } from '~Styles';
import { addToast } from '~actions';

const ZonesSettings = () => {
  const [storage, updateStorage, storageLoading] = useStorage();
  const zones = useSelector((state) => state.zones ?? []);
  const dispatch = useDispatch();
  const { i18n } = useI18n();
  const logger = useLogger('settings-v2');

  const update = (id: string) => {
    logger.info('Updating Settings (change zone)', {
      fields: { selectedZoneId: id },
    });
    updateStorage({ zoneId: id === 'NONE' ? null : id });
    dispatch(addToast(i18n('TOAST.Zone.Updated'), true));
  };

  if (storageLoading) {
    return null;
  }

  return (
    <Box padding="large">
      <Heading level={4} bottom={8} color="#fff">
        {i18n('Settings.Zone.Choose')}
      </Heading>
      <SelectList
        list={[
          {
            id: 'NONE',
            name: i18n('Settings.ZoneNone') + ' ' + i18n('Settings.ZoneDontAssign'),
          },
          ...zones.map((zone) => ({
            id: zone.id,
            name: zone.name,
          })),
        ]}
        selectedId={storage.zoneId ?? 'NONE'}
        onSelect={update}
        dark
      />
    </Box>
  );
};

export default ZonesSettings;
